import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, retry } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DeleteUsersBBDDService {

  headers = new HttpHeaders();

  constructor(private readonly http: HttpClient) { }

  /**
   * 
   * @param token: string
   * @param id: string
   */
  deleteUser = (id) => {
    return this.http.post<any>(environment.url + '/MG/UserDelete', { CodeRegistration: id }, {
      headers: this.headers.set('Authorization',
        sessionStorage.getItem('t_admin'))
    }).pipe(retry(0), catchError(this.errorHandl));
  }


  /**
   * Control errores generico para todas las llamadas
   * @param error: Object
   */
  errorHandl(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
